
import { supabase } from '../../client';
import { Customer } from '../types';
import { addShopInfoToCustomers } from './customerShops';

/**
 * Get all customers for an organization without shop filter
 */
export const getOrganizationCustomers = async (organizationId: string): Promise<Customer[]> => {
  try {
    console.log("[getOrganizationCustomers] Fetching all customers for organization using get_customers_with_stats function");
    
    // Log the exact query parameters to debug the issue
    console.log(`[getOrganizationCustomers] Searching with organization_id: ${organizationId}`);
    
    // Use the database function to get customers with their stats
    const { data: customers, error } = await supabase
      .rpc('get_customers_with_stats', { org_id: organizationId });
      
    if (error) {
      console.error('[getOrganizationCustomers] Error retrieving customers:', error);
      return [];
    }
    
    console.log(`[getOrganizationCustomers] Retrieved ${customers?.length || 0} customers with stats`);
    
    if (customers && customers.length > 0) {
      // Add shop information to the customers
      const customersWithShops = await addShopInfoToCustomers(customers);
      return customersWithShops;
    } else {
      console.log("[getOrganizationCustomers] No customers found for this organization");
      return [];
    }
  } catch (error) {
    console.error('[getOrganizationCustomers] Unhandled error:', error);
    return [];
  }
};
